import React from "react";
import Div from "../../../widget/common/ui/Div";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppConfigService from "../../../service/app_config/AppConfigService";
import { LogoImage } from "../../../widget/common/ui/Logo";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { BranchSwicthSplashContextImport } from "../../../provider/branch/branch_switch_splash/BranchSwicthSplashContextProvider";

const BranchSwitchSplashContent = () => {
  const type: number = ResponsiveDeviceType();
  const flashLogo = AppConfigService.get("company_flash_logo");
  const { getBranchDetail } = BranchSwicthSplashContextImport();

  const handleLoaded = async () => {
    await UtilityHelper.delay(1000);
    getBranchDetail();
  };

  return (
    <Div className="launch-logo d-center">
      <Div>
        <LogoImage
          url={flashLogo}
          size={type === 3 ? 250 : `80%`}
          name={AppConfigService.get("company_name")}
          classNameWrap="mx-auto"
          loadedCallBack={handleLoaded}
        />
      </Div>
    </Div>
  );
};

export default BranchSwitchSplashContent;
